<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="editProductNameModal" persistent max-width="540px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">Edit Product Name</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeEditProductNameModal()" class="close"><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert :value="seccessAlert" type="success">
                Product Name updated successfully
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm5 md5>
                    <v-text-field
                      label="Product Name"
                      v-model="editProductNameData.product_name"
                      :error-messages="errors.collect('Product Name')"
                      v-validate="'required'"
                      data-vv-name="Product Name"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height:auto; margin-right: 20px"
                outline
                color="success"
                >Save</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'seccessAlert',
    'editProductNameModal',
    'closeEditProductNameModal',
    'editProductNameData',
    'editProductName',
    'UrlError'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editProductName()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/editProductName.vue